import React from 'react';
import { motion } from 'framer-motion';

const LoadingScreen = () => {
  return (
    <motion.div 
      className="fixed inset-0 bg-luxury-darkCharcoal flex items-center justify-center z-50"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div
        className="text-center"
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <motion.img
          src="https://i.ibb.co/q3wdWB9T/Nashmi-barber-shop-Logo.jpg"
          alt="Nashmi Barber Shop"
          className="w-32 h-32 mx-auto mb-4 rounded-full border-4 border-luxury-gold"
          animate={{ rotate: 360 }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
        />
        <motion.h1 
          className="text-luxury-gold text-2xl font-bold mb-2"
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 1.5, repeat: Infinity }}
        >
          Nashmi Barber Shop
        </motion.h1>
        <motion.div 
          className="flex space-x-1 justify-center"
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 1, repeat: Infinity }}
        >
          <div className="w-2 h-2 bg-luxury-gold rounded-full"></div>
          <div className="w-2 h-2 bg-luxury-gold rounded-full"></div>
          <div className="w-2 h-2 bg-luxury-gold rounded-full"></div>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default LoadingScreen;